import { Component, OnInit, Output } from "@angular/core";
import { BaseComponent } from "../../base/base.component";
import { LoginGQL } from "../../../generated/graphql";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { UserService } from "../../service/user.service";
import { environment } from "../../../environments/environment";
import { LoginByReGQL } from "graphql/login-re/login-re.definition";
import { HttpErrorResponse } from "@angular/common/http";
import { LoginByRe } from "src/app/model/login-re";

declare var $: any;

@Component({
  selector: "app-authenticate",
  templateUrl: "./authenticate.component.html",
  styleUrls: ["./authenticate.component.scss"],
})
export class AuthenticateComponent extends BaseComponent implements OnInit {
  @Output()
  accessType: string;
  error = "";
  model: any = {
    code: "",
    application: "",
    email: "",
    redirectUri:
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname,
    re: "",
    access_token: "",
  };
  modelEmailMock = "";
  cultures = {
    BR: "pt-BR",
    ES: "es-ES",
    EN: "en-US",
  };
  user;
  showEmployeeForm;
  modelReMock = "";

  constructor(
    public router: Router,
    public translate: TranslateService,
    public service: UserService,
    public login: LoginGQL,
    public route: ActivatedRoute,
    private loginByReGQL: LoginByReGQL,
  ) {
    super(router, translate);
  }

  ngOnInit(): void {
    this.toggleLoader(false);

    this.accessType = this.route.snapshot.paramMap.get("accessType");

    if (!environment.production) {
      this.showModal("modalLoginEmail");
      return;
    }

    this.route.queryParams.subscribe((data) => {
      if (data.error != null) {
        this.error = data.error_description;
        return;
      }
      if (data.code != null) {
        this.model.code = data.code;
        this.onLogin();
        return;
      }
      this.redirectAuth();
    });
  }

  handleLogin() {
    environment.production ? this.redirectAuth() : this.onLoginMock();
  }

  redirectAuth() {
    const p = window.location.pathname.split("/");
    const virtualPath = p.length >= 3 ? "/" + p[1] : "/authenticate";
    const redirectUrl = window.location.origin + virtualPath;
    const authUrl =
      "https://login.microsoftonline.com/" +
      environment.tenant_id +
      "/oauth2/v2.0/authorize?client_id=" +
      environment.client_id +
      "&response_type=code&redirect_uri=" +
      redirectUrl +
      "&response_mode=query&scope=openid%20offline_access%20https://graph.microsoft.com/mail.read&state=12345" +
      // prompt=login força a Microsoft a exigir autenticação completa a cada login (não afeta o login por RE).
      "&prompt=login";
    window.location.href = authUrl;
  }

  onLogin() {
    this.model.application = "web";
    if (this.modelReMock) {
      this.model.re = this.modelReMock;
      this.model.code = this.route.snapshot.queryParamMap.get("code");
    }
    this.login.mutate(this.model).subscribe(
      async (response) => {
        if (response.data.login.requiresEmployee) {
          this.showEmployeeForm = true;
          this.user = response.data?.login?.user;
          this.model.access_token = response.data?.login?.access_token;
          this.showModal("reModal");
        } else {
          const data = response.data;
          await this.saveLocalUser(data);
        }
      },
      (err) => {
        super.onError(err);
      },
    );
  }

  async saveLocalUser(data) {
    const cultureKeys = Object.keys(this.cultures);
    cultureKeys.includes(data.login.country)
      ? localStorage.setItem("culture", this.cultures[data.login.country])
      : localStorage.setItem("culture", this.cultures.BR);
    if (data.login) {
      localStorage.setItem("kaizen", data.login.kaizen);
      localStorage.setItem("role", data.login.user?.role);
      this.setToken(data.login.token);
    } else {
      this.setToken(data.code);
    }
    const isAuthenticated = this.service.getStatusAuthenticated();
    if (isAuthenticated) {
      $(".modal").modal("hide"); // Fecha modais ativos
      $(".modal-backdrop").remove(); // Remove backdrop remanescente
      $("body").removeClass("modal-open"); // Evita bloqueio de scroll
      await this.router.navigate(["/home"]);
    }
  }

  onLoginMock() {
    const arrValidateFields = [
      {
        value: this.modelEmailMock,
        text: `${this.translate.instant("email")}<br>`,
      },
    ];
    const stringError = this.validateField(arrValidateFields);
    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(
        this.translate.instant("É preciso inserir um email válido"),
        `${this.translate.instant("Error: ")} ${stringError}`,
      );
      return;
    }
    this.closeModal("modalLoginEmail");
    this.model.email = this.modelEmailMock;
    this.model.re = this.modelReMock;
    this.onLogin();
  }

  closeLoginMock() {
    this.closeModal("modalLoginEmail");
    this.router.navigate(["/logout"]);
  }

  onLoginWithRE(loginReData: LoginByRe) {
    loginReData.cpf = this.formatCPF(loginReData.cpf);
    this.loginByReGQL.mutate({ data: loginReData }).subscribe({
      next: (response) => {
        sessionStorage.setItem("token", response.data.loginV2.token);
        localStorage.setItem("re", response.data.loginV2.employee.re);
        this.router.navigate(["/home"]);
      },
      error: (error: HttpErrorResponse) => {
        this.onError(error);
      },
    });
  }

  private formatCPF(cpf: string): string {
    if (cpf.length !== 11) {
      throw new Error("Invalid CPF length. CPF should be 11 digits.");
    }

    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }
}
